var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col mx-0 px-0 py-1"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g({staticClass:"red",attrs:{"outlined":"","x-small":"","fab":"","dark":"","loading":_vm.loading},on:{"click":function($event){return _vm.getDetailsGroupe(_vm.id_groupe)}}},on),[_c('v-icon',[_vm._v("mdi-alert-circle")])],1)]}}])},[_c('span',[_vm._v("Vérifier")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }